import { forwardRef, useCallback, useImperativeHandle, useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { PresentUrl, declarationFormApi, selfOnboardDataFetchApi } from "../../../text/apidata.js";
import { setSelfonboardingDataFetchResponse } from "../../../Redux/Slice.js";
import { store } from "../../../Redux/Store.js";
import { getLoaderAction2 } from "../../../Redux/Loader2.js";
import {
  selectEmployeeInformation,
  updateDeclarationField,
  setDeclarationImage,
  removeDeclarationImage,
} from "../../../Redux/employeeInformationSlice.js";
import styles from "./DeclarationForm.module.scss";

const familyOptions = [
  "FATHER",
  "MOTHER",
  "SPOUSE",
  "SON",
  "DAUGHTER",
  "GUARDIAN",
];

const DeclarationForm = forwardRef(function DeclarationForm(_, ref) {
  const dispatch = useDispatch();

  const {
    declarationDetails: form,
    declarationImages,
    basicInformation,
    bankDetails,
  } = useSelector(selectEmployeeInformation);

  const selfonboardData = useSelector(
    (state) => state.selfonboardingretriveslice?.Selfonboarding_Data
  );
  const selfonboardDataFetch = useSelector(
    (state) => state.selfonboarddatafetchslice?.Selfonboarding_DataFetch_Data
  );
  const employeeDetails = useSelector(
    (state) => state.Signature_Employee_RetrieveCall_actions?.Signature_Employee_Datas
  );

  const [errorFields, setErrorFields] = useState(new Set());

  const extractDeclarationFormId = (d) => {
    if (!d) return null;
    const raw =
      d?.employeetimeline_id?.declaration_form ||
      d?.employeetimeline_id?.declaration_details_form ||
      d?.declaration_details_form?.id ||
      d?.declaration_details_form ||
      d?.declaration_form_id ||
      d?.declaration_form ||
      d?.declarationform_id;

    if (typeof raw === "object" && raw !== null) {
      return raw.id || raw._id || null;
    }
    return raw ? String(raw) : null;
  };

  const fetchedDeclarationFormIdRef = useRef(null);

  // GET Declaration Form API on mount
  useEffect(() => {
    const details = selfonboardDataFetch || selfonboardData || employeeDetails;
    if (!details) {
      dispatch(getLoaderAction2(false));
      return;
    }

    const declarationFormId = extractDeclarationFormId(details);
    if (!declarationFormId) {
      const fieldMap = {
        relation: details.relation || details.family_member || details.declaration_form?.relation || "",
        relation_name: details.relation_name || details.person_name || details.relation_name_type || details.declaration_form?.relation_name || "",
        marital_status: details.marital_status || details.declaration_form?.marital_status || "unmarried",
        email: details.email_id || details.email || details.declaration_form?.email || details.basic_info?.email_id || "",
        universal_acc_number: details.universal_acc_number || details.uan || details.universal_acc_no || details.declaration_form?.universal_acc_number || "",
        pf_acc_number: details.pf_acc_number || details.previous_pf || details.pf_acc_no || details.declaration_form?.pf_acc_number || "",
        previous_end_date: details.previous_end_date || details.exit_date || details.declaration_form?.previous_end_date || "",
        scheme_number: details.scheme_number || details.scheme_certificate || details.declaration_form?.scheme_number || "",
        ppo_number: details.ppo_number || details.declaration_form?.ppo_number || "",
        provident_fund_schema: Boolean(details.provident_fund_schema ?? details.declaration_form?.provident_fund_schema),
        pension_schema: Boolean(details.pension_schema ?? details.declaration_form?.pension_schema),
        is_international: Boolean(details.is_international ?? details.declaration_form?.is_international),
        origin_country: details.origin_country || details.country_of_origin || details.declaration_form?.origin_country || "",
        passport_number: details.passport_number || details.declaration_form?.passport_number || "",
        passport_validity_from: details.passport_validity_from || details.declaration_form?.passport_validity_from || "",
        passport_validity_to: details.passport_validity_to || details.declaration_form?.passport_validity_to || "",
        bank_acc_ifsc: details.bank_acc_ifsc || details.bank_acc_no || details.account_number || details.bank_account_number || details.bank_details?.account_number || details.declaration_form?.bank_acc_ifsc || "",
        ifsc_code: details.ifsc_code || details.ifsc || details.bank_details?.ifsc_code || details.declaration_form?.ifsc_code || "",
        aadhar_number: details.aadhar_number || details.aadhaar_number || details.basic_info?.aadhar_number || details.declaration_form?.aadhar_number || "",
        pan_number: details.pan_number || details.pan || details.id_verification?.pan_number || details.declaration_form?.pan_number || "",
        employee_name: details.employee_name || details.name || details.first_name || details.basic_info?.first_name || details.declaration_form?.employee_name || "",
        mobile_no: details.mobile_no || details.phone_number || details.phoneNum || details.basic_info?.phone_number || details.declaration_form?.mobile_no || "",
        date_of_birth: details.date_of_birth || details.dob || details.DateofBirth || details.basic_info?.date_of_birth || details.declaration_form?.date_of_birth || "",
        gender: details.gender || details.basic_info?.gender || details.declaration_form?.gender || "",
      };

      Object.entries(fieldMap).forEach(([name, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          dispatch(updateDeclarationField({ name, value }));
        }
      });

      if (fetchedDeclarationFormIdRef.current === "DATA_FETCH") {
        dispatch(getLoaderAction2(false));
        return;
      }
      fetchedDeclarationFormIdRef.current = "DATA_FETCH";

      const sessionToken =
        details?.session_token ||
        details?.token ||
        details?.sessionToken ||
        store?.getState()?.users?.UserData?.session?.token ||
        localStorage.getItem("token") ||
        localStorage.getItem("session_token");

      if (sessionToken) {
        const headers = {
          Authorization: String(sessionToken).startsWith("Bearer ")
            ? sessionToken
            : `Bearer ${sessionToken}`,
        };

        dispatch(getLoaderAction2(true));
        axios
          .get(selfOnboardDataFetchApi, { headers })
          .then((res) => {
            console.log("selfOnboardDataFetchApi response in DeclarationForm:", res.data);
            const data = res.data?.data || res.data;
            if (data) {
              console.log(data, "dajkdajkjdas", res?.data);
              dispatch(setSelfonboardingDataFetchResponse(data));

              const resFieldMap = {
                relation: data.relation || data.family_member || data.declaration_form?.relation || "",
                relation_name: data.relation_name || data.person_name || data.relation_name_type || data.declaration_form?.relation_name || "",
                marital_status: data.marital_status || data.declaration_form?.marital_status || "unmarried",
                email: data.email_id || data.email || data.declaration_form?.email || data.basic_info?.email_id || "",
                universal_acc_number: data.universal_acc_number || data.uan || data.universal_acc_no || data.declaration_form?.universal_acc_number || "",
                pf_acc_number: data.pf_acc_number || data.previous_pf || data.pf_acc_no || data.declaration_form?.pf_acc_number || "",
                previous_end_date: data.previous_end_date || data.exit_date || data.declaration_form?.previous_end_date || "",
                scheme_number: data.scheme_number || data.scheme_certificate || data.declaration_form?.scheme_number || "",
                ppo_number: data.ppo_number || data.declaration_form?.ppo_number || "",
                provident_fund_schema: Boolean(data.provident_fund_schema ?? data.declaration_form?.provident_fund_schema),
                pension_schema: Boolean(data.pension_schema ?? data.declaration_form?.pension_schema),
                is_international: Boolean(data.is_international ?? data.declaration_form?.is_international),
                origin_country: data.origin_country || data.country_of_origin || data.declaration_form?.origin_country || "",
                passport_number: data.passport_number || data.declaration_form?.passport_number || "",
                passport_validity_from: data.passport_validity_from || data.declaration_form?.passport_validity_from || "",
                passport_validity_to: data.passport_validity_to || data.declaration_form?.passport_validity_to || "",
                bank_acc_ifsc: data.bank_acc_ifsc || data.bank_acc_no || data.account_number || data.bank_account_number || data.bank_details?.account_number || data.declaration_form?.bank_acc_ifsc || "",
                ifsc_code: data.ifsc_code || data.ifsc || data.bank_details?.ifsc_code || data.declaration_form?.ifsc_code || "",
                aadhar_number: data.aadhar_number || data.aadhaar_number || data.basic_info?.aadhar_number || data.declaration_form?.aadhar_number || "",
                pan_number: data.pan_number || data.pan || data.id_verification?.pan_number || data.declaration_form?.pan_number || "",
                employee_name: data.employee_name || data.name || data.first_name || data.basic_info?.first_name || data.declaration_form?.employee_name || "",
                mobile_no: data.mobile_no || data.phone_number || data.phoneNum || data.basic_info?.phone_number || data.declaration_form?.mobile_no || "",
                date_of_birth: data.date_of_birth || data.dob || data.DateofBirth || data.basic_info?.date_of_birth || data.declaration_form?.date_of_birth || "",
                gender: data.gender || data.basic_info?.gender || data.declaration_form?.gender || "",
              };

              Object.entries(resFieldMap).forEach(([name, value]) => {
                if (value !== undefined && value !== null && value !== "") {
                  dispatch(updateDeclarationField({ name, value }));
                }
              });

              const passportObj =
                data?.passport_id ||
                data?.passport ||
                data?.passport_file ||
                data?.passport_image ||
                data?.declaration_form?.passport_id;

              const passportUrl =
                (typeof passportObj === "object" && passportObj !== null
                  ? passportObj?.media_url || passportObj?.url
                  : typeof passportObj === "string"
                    ? passportObj
                    : "") || "";

              if (passportUrl) {
                dispatch(updateDeclarationField({ name: "passport", value: passportUrl }));
                dispatch(
                  setDeclarationImage({
                    name: "passport",
                    image: {
                      name: "Passport Image",
                      url: passportUrl,
                      s3Url: passportUrl,
                    },
                  })
                );
              }
            }
          })
          .catch((err) => {
            console.error("Error fetching selfOnboardDataFetchApi in DeclarationForm:", err);
          })
          .finally(() => {
            dispatch(getLoaderAction2(false));
          });
      } else {
        dispatch(getLoaderAction2(false));
      }
      return;
    }

    if (fetchedDeclarationFormIdRef.current === declarationFormId) {
      dispatch(getLoaderAction2(false));
      return;
    }
    fetchedDeclarationFormIdRef.current = declarationFormId;

    const sessionToken =
      details?.session_token ||
      details?.token ||
      details?.sessionToken ||
      store?.getState()?.users?.UserData?.session?.token;

    const headers = sessionToken
      ? {
        Authorization: String(sessionToken).startsWith("Bearer ")
          ? sessionToken
          : `Bearer ${sessionToken}`,
      }
      : {};

    dispatch(getLoaderAction2(true));

    axios
      .get(`${declarationFormApi}${declarationFormId}/`, { headers })
      .then((res) => {
        console.log("Declaration form GET API response:", res.data);
        const data = res.data?.data || res.data;
        if (data) {
          const fieldMap = {
            relation: data.relation || data.family_member || "",
            relation_name: data.relation_name || data.person_name || "",
            marital_status: data.marital_status || "unmarried",
            email: data.email_id || data.email || "",
            universal_acc_number: data.universal_acc_number || data.uan || "",
            pf_acc_number: data.pf_acc_number || data.previous_pf || "",
            previous_end_date: data.previous_end_date || data.exit_date || "",
            scheme_number: data.scheme_number || data.scheme_certificate || "",
            ppo_number: data.ppo_number || "",
            provident_fund_schema: Boolean(data.provident_fund_schema),
            pension_schema: Boolean(data.pension_schema),
            is_international: Boolean(data.is_international),
            origin_country: data.origin_country || data.country_of_origin || "",
            passport_number: data.passport_number || "",
            passport_validity_from: data.passport_validity_from || "",
            passport_validity_to: data.passport_validity_to || "",
            bank_acc_ifsc: data.bank_acc_ifsc || "",
            ifsc_code: data.ifsc_code || "",
            aadhar_number: data.aadhar_number || "",
            pan_number: data.pan_number || "",
          };

          Object.entries(fieldMap).forEach(([name, value]) => {
            if (value !== undefined && value !== null) {
              dispatch(updateDeclarationField({ name, value }));
            }
          });

          const passportObj =
            data?.passport_id ||
            data?.passport ||
            data?.passport_file ||
            data?.passport_image;

          const passportUrl =
            (typeof passportObj === "object" && passportObj !== null
              ? passportObj?.media_url || passportObj?.url
              : typeof passportObj === "string"
                ? passportObj
                : "") || "";

          if (passportUrl) {
            dispatch(updateDeclarationField({ name: "passport", value: passportUrl }));
            dispatch(
              setDeclarationImage({
                name: "passport",
                image: {
                  name: "Passport Image",
                  url: passportUrl,
                  s3Url: passportUrl,
                },
              })
            );
          }
        }
      })
      .catch((err) => {
        console.error("Error fetching Declaration form GET API:", err);
      })
      .finally(() => {
        dispatch(getLoaderAction2(false));
      });
  }, [dispatch, selfonboardData, employeeDetails]);

  const clearError = (name) => {
    setErrorFields((prev) => {
      const next = new Set(prev);
      next.delete(name);
      return next;
    });
  };

  const updateField = (name, value) => {
    dispatch(updateDeclarationField({ name, value }));
    clearError(name);
  };

  // Auto-filled values from previous sections or API response
  const employeeName = basicInformation.first_name || form.employee_name || "";
  const mobileNo = basicInformation.phoneNum || form.mobile_no || "";
  const email = basicInformation.email_id || form.email || "";
  const dateOfBirth = basicInformation.DateofBirth || form.date_of_birth || "";
  const gender = basicInformation.gender || form.gender || "";
  const aadhaarNumber = basicInformation.aadhar_number || form.aadhar_number || "";

  const bankAccount = bankDetails.account_number || form.bank_acc_ifsc || form.bank_account || "";
  const ifscCode = bankDetails.ifsc_code || form.ifsc_code || "";

  const handleFamilySelect = (value) => {
    updateField("relation", value);
    updateField("relation_name", "");
  };

  const clearPerson = () => {
    updateField("relation", "");
    updateField("relation_name", "");
  };

  const handleImage = async (file) => {
    if (!file || file.size > 10 * 1024 * 1024) return;

    if (declarationImages.passport?.url) {
      URL.revokeObjectURL(declarationImages.passport.url);
    }

    const localUrl = URL.createObjectURL(file);

    dispatch(
      setDeclarationImage({
        name: "passport",
        image: {
          name: file.name,
          file,
          url: localUrl,
          s3Url: "",
        },
      })
    );

    const details = selfonboardData || employeeDetails;
    const sessionToken =
      details?.session_token ||
      details?.token ||
      details?.sessionToken ||
      store?.getState()?.users?.UserData?.session?.token;

    const headers = sessionToken
      ? {
        Authorization: String(sessionToken).startsWith("Bearer ")
          ? sessionToken
          : `Bearer ${sessionToken}`,
      }
      : {};

    dispatch(getLoaderAction2(true));

    try {
      const folderName = "passport";
      const randomNumber = Math.floor(Math.random() * 10000000000);
      const fileExt = file.name.split(".").pop() || "jpg";
      const formattedFilename = `onboarding/${folderName}/${folderName}${randomNumber}.${fileExt}`;

      const presignedReqData = {
        multiple_files: [
          {
            filename: formattedFilename,
            file_type: file.type || "image/jpeg",
          },
        ],
      };

      const presignedRes = await axios.post(PresentUrl, presignedReqData, { headers });
      const uploadedUrls = presignedRes.data?.data || presignedRes.data;

      let s3CleanUrl = "";
      if (Array.isArray(uploadedUrls) && uploadedUrls.length > 0) {
        const presignedPutUrl = uploadedUrls[0];
        s3CleanUrl = String(presignedPutUrl).split("?")[0];

        await fetch(presignedPutUrl, {
          method: "PUT",
          headers: {
            "Content-Type": file.type || "image/jpeg",
            "x-amz-acl": "public-read",
          },
          body: file,
        });
      }

      const finalS3Url = s3CleanUrl || localUrl;

      dispatch(
        setDeclarationImage({
          name: "passport",
          image: {
            name: file.name,
            file,
            url: finalS3Url,
            s3Url: finalS3Url,
          },
        })
      );
      updateField("passport", finalS3Url);
    } catch (err) {
      console.error("Presigned URL upload error for passport image:", err);
    } finally {
      dispatch(getLoaderAction2(false));
    }

    clearError("passport");
  };

  const removeImage = () => {
    if (declarationImages.passport?.url) {
      URL.revokeObjectURL(declarationImages.passport.url);
    }

    dispatch(removeDeclarationImage("passport"));
    updateField("passport", "");
  };

  const getMissingFields = useCallback(() => {
    const missing = [];
    const missingNames = new Set();

    if (!String(form.relation || "").trim()) {
      missing.push("Family Member");
      missingNames.add("relation");
    }

    if (!String(form.relation_name || "").trim()) {
      missing.push("Family Member Name");
      missingNames.add("relation_name");
    }

    const uanVal = String(form.universal_acc_number || "").trim();
    if (!uanVal || uanVal.length !== 12) {
      missing.push("Universal Account Number (12 digits required)");
      missingNames.add("universal_acc_number");
    }

    if (form.is_international) {
      if (!String(form.origin_country || "").trim()) {
        missing.push("Country of Origin");
        missingNames.add("origin_country");
      }

      if (!String(form.passport_number || "").trim()) {
        missing.push("Passport Number");
        missingNames.add("passport_number");
      }

      if (!form.passport_validity_from) {
        missing.push("Passport Validity From");
        missingNames.add("passport_validity_from");
      }

      if (!form.passport_validity_to) {
        missing.push("Passport Validity To");
        missingNames.add("passport_validity_to");
      }
    }

    setErrorFields(missingNames);
    return missing;
  }, [form]);

  useImperativeHandle(ref, () => ({
    getMissingFields,
    isComplete: () => getMissingFields().length === 0,
  }));

  return (
    <div className={styles.declaration}>
      <header className={styles.sectionHeader}>Declaration Form</header>

      <div className={styles.content}>
        <div className={styles.formGrid}>
          <label className={styles.field}>
            <span>Employee Name</span>
            <input value={employeeName} disabled />
          </label>

          <label className={styles.field}>
            <span>
              Select Family Member<b>*</b>
            </span>
            <select
              value={form.relation || ""}
              className={errorFields.has("relation") ? styles.inputError : ""}
              onChange={(e) => handleFamilySelect(e.target.value)}
            >
              <option value="">Select</option>
              {familyOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
            {errorFields.has("relation") && (
              <p className={styles.fieldError}>Please select a family member</p>
            )}
          </label>

          <label className={styles.field}>
            <span>
              Family Member Name<b>*</b>
            </span>
            <div className={styles.inlineField}>
              <input
                value={form.relation_name || ""}
                disabled={!form.relation}
                placeholder="Selected family member name"
                className={
                  errorFields.has("relation_name") ? styles.inputError : ""
                }
                onChange={(e) =>
                  updateField("relation_name", e.target.value.toUpperCase())
                }
              />
              {form.relation_name && (
                <button
                  type="button"
                  className={styles.closeBtn}
                  onClick={clearPerson}
                >
                  ×
                </button>
              )}
            </div>
            {errorFields.has("relation_name") && (
              <p className={styles.fieldError}>Please fill this field</p>
            )}
          </label>

          {/*
          <label className={styles.field}>
            <span>Date of Birth</span>
            <input value={dateOfBirth} disabled />
          </label>

          <label className={styles.field}>
            <span>Gender</span>
            <input value={gender} disabled />
          </label>
          */}

          <label className={styles.field}>
            <span>Marital Status</span>
            <select
              value={form.marital_status || "unmarried"}
              onChange={(e) => updateField("marital_status", e.target.value)}
            >
              <option value="unmarried">UNMARRIED</option>
              <option value="married">MARRIED</option>
              <option value="others">OTHERS</option>
            </select>
          </label>

          {/*
          <label className={styles.field}>
            <span>Email</span>
            <input
              value={form.email || email}
              onChange={(e) => updateField("email", e.target.value)}
            />
          </label>

          <label className={styles.field}>
            <span>Mobile No</span>
            <input value={mobileNo} disabled />
          </label>
          */}

          <label className={styles.field}>
            <span>
              Universal Account Number<b>*</b>
            </span>
            <input
              value={form.universal_acc_number || ""}
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={12}
              className={
                errorFields.has("universal_acc_number") ? styles.inputError : ""
              }
              onChange={(e) =>
                updateField(
                  "universal_acc_number",
                  e.target.value.replace(/\D/g, "").slice(0, 12)
                )
              }
            />
            {errorFields.has("universal_acc_number") && (
              <p className={styles.fieldError}>
                Please enter a valid 12-digit UAN number
              </p>
            )}
          </label>

          <label className={styles.field}>
            <span>Previous PF Account Number</span>
            <input
              value={form.pf_acc_number || ""}
              onChange={(e) => updateField("pf_acc_number", e.target.value)}
            />
          </label>

          <label className={styles.field}>
            <span>Date of Exit From Previous Employment</span>
            <input
              type="date"
              value={form.previous_end_date || ""}
              onChange={(e) => updateField("previous_end_date", e.target.value)}
            />
          </label>

          <label className={styles.field}>
            <span>Scheme Certificate Number</span>
            <input
              value={form.scheme_number || ""}
              onChange={(e) => updateField("scheme_number", e.target.value)}
            />
          </label>

          <label className={styles.field}>
            <span>Pension Payment Order</span>
            <input
              value={form.ppo_number || ""}
              onChange={(e) => updateField("ppo_number", e.target.value)}
            />
          </label>

          <label className={styles.field}>
            <span>Earlier PF Member</span>
            <div className={styles.inlineOptions}>
              {[true, false].map((value) => (
                <label key={String(value)}>
                  <input
                    type="radio"
                    checked={form.provident_fund_schema === value}
                    onChange={() => updateField("provident_fund_schema", value)}
                  />
                  {value ? "Yes" : "No"}
                </label>
              ))}
            </div>
          </label>

          <label className={styles.field}>
            <span>Earlier Pension Scheme 1995</span>
            <div className={styles.inlineOptions}>
              {[true, false].map((value) => (
                <label key={String(value)}>
                  <input
                    type="radio"
                    checked={form.pension_schema === value}
                    onChange={() => updateField("pension_schema", value)}
                  />
                  {value ? "Yes" : "No"}
                </label>
              ))}
            </div>
          </label>

          <label className={styles.field}>
            <span>International Workers</span>
            <div className={styles.inlineOptions}>
              {[true, false].map((value) => (
                <label key={String(value)}>
                  <input
                    type="radio"
                    checked={form.is_international === value}
                    onChange={() => {
                      updateField("is_international", value);

                      if (!value) {
                        updateField("origin_country", "");
                        updateField("passport_number", "");
                        updateField("passport_validity_from", null);
                        updateField("passport_validity_to", null);
                      }
                    }}
                  />
                  {value ? "Yes" : "No"}
                </label>
              ))}
            </div>
          </label>

          {form.is_international && (
            <>
              <label className={styles.field}>
                <span>
                  Country of Origin<b>*</b>
                </span>
                <input
                  value={form.origin_country || ""}
                  className={
                    errorFields.has("origin_country") ? styles.inputError : ""
                  }
                  onChange={(e) =>
                    updateField("origin_country", e.target.value.toUpperCase())
                  }
                />
              </label>

              <label className={styles.field}>
                <span>
                  Passport Number<b>*</b>
                </span>
                <input
                  value={form.passport_number || ""}
                  className={
                    errorFields.has("passport_number") ? styles.inputError : ""
                  }
                  onChange={(e) =>
                    updateField("passport_number", e.target.value.toUpperCase())
                  }
                />
              </label>

              <label className={styles.field}>
                <span>
                  Validity of Passport (From)<b>*</b>
                </span>
                <input
                  type="date"
                  value={form.passport_validity_from || ""}
                  className={
                    errorFields.has("passport_validity_from")
                      ? styles.inputError
                      : ""
                  }
                  onChange={(e) =>
                    updateField("passport_validity_from", e.target.value)
                  }
                />
              </label>

              <label className={styles.field}>
                <span>
                  Validity of Passport (To)<b>*</b>
                </span>
                <input
                  type="date"
                  value={form.passport_validity_to || ""}
                  className={
                    errorFields.has("passport_validity_to")
                      ? styles.inputError
                      : ""
                  }
                  onChange={(e) =>
                    updateField("passport_validity_to", e.target.value)
                  }
                />
              </label>
            </>
          )}

          {/* <label className={styles.field}>
            <span>Bank Account No</span>
            <input value={bankAccount} disabled />
          </label>

          <label className={styles.field}>
            <span>IFSC Code</span>
            <input value={ifscCode} disabled />
          </label>

          <label className={styles.field}>
            <span>Aadhaar Number</span>
            <input value={aadhaarNumber} disabled />
          </label>

          <label className={styles.field}>
            <span>PAN Number</span>
            <input
              value={form.pan_number || ""}
              onChange={(e) =>
                updateField("pan_number", e.target.value.toUpperCase())
              }
            />
          </label> */}
        </div>

        <div className={styles.uploadBlock}>
          <span>Passport Image</span>

          <p className={styles.note}>
            Note: Upload the passport image in JPG, JPEG, or PNG format. Maximum
            size: 10 MB.
          </p>

          {(() => {
            const imgObj = declarationImages.passport || form.passport;
            let passportSrc = "";
            if (typeof imgObj === "string") {
              passportSrc = imgObj;
            } else if (typeof imgObj === "object" && imgObj !== null) {
              if (typeof imgObj.url === "object" && imgObj.url !== null) {
                passportSrc = imgObj.url.media_url || imgObj.url.url || "";
              } else {
                passportSrc = imgObj.url || imgObj.media_url || imgObj.s3Url || "";
              }
            }

            if (!passportSrc) return null;

            return (
              <div className={styles.previewRow}>
                <img
                  src={passportSrc}
                  alt="Passport preview"
                  className={styles.imagePreview}
                />
                <button
                  type="button"
                  className={styles.removeButton}
                  onClick={removeImage}
                >
                  Remove Image
                </button>
              </div>
            );
          })() || (
              <label className={styles.uploadButton}>
                Upload Image
                <input
                  type="file"
                  className={styles.hiddenInput}
                  accept="image/png,image/jpeg,image/jpg"
                  onChange={(e) => handleImage(e.target.files?.[0])}
                />
              </label>
            )}
        </div>
      </div>
    </div>
  );
});

export default DeclarationForm;
